export interface VolumeChartRect {
  left: number
  top: number
  width: number
  height: number
}

export interface VolumeCrosshairPoint {
  x: number
  y: number
  index: number
  alignLeft: boolean
  placeBelow: boolean
}

export interface VolumeChartMetrics {
  offsetWidth: number
  offsetHeight: number
  clientWidth: number
  clientHeight: number
  clientLeft: number
  clientTop: number
}

function clamp(value: number, minimum: number, maximum: number) {
  return Math.min(Math.max(value, minimum), maximum)
}

export function volumeCrosshairPoint(clientX: number, clientY: number, rect: VolumeChartRect, itemCount: number): VolumeCrosshairPoint {
  const x = clamp(clientX - rect.left, 0, Math.max(0, rect.width))
  const y = clamp(clientY - rect.top, 0, Math.max(0, rect.height))
  const horizontalRatio = rect.width > 0 ? x / rect.width : 0
  const index = itemCount > 0
    ? clamp(Math.floor(horizontalRatio * itemCount), 0, itemCount - 1)
    : -1

  return {
    x,
    y,
    index,
    alignLeft: horizontalRatio > .68,
    placeBelow: y < 58,
  }
}

export function scaledVolumeCrosshairPoint(clientX: number, clientY: number, bounds: VolumeChartRect, metrics: VolumeChartMetrics, itemCount: number) {
  const scaleX = metrics.offsetWidth > 0 ? bounds.width / metrics.offsetWidth : 1
  const scaleY = metrics.offsetHeight > 0 ? bounds.height / metrics.offsetHeight : 1
  const visualPoint = volumeCrosshairPoint(clientX, clientY, {
    left: bounds.left + metrics.clientLeft * scaleX,
    top: bounds.top + metrics.clientTop * scaleY,
    width: metrics.clientWidth * scaleX,
    height: metrics.clientHeight * scaleY,
  }, itemCount)
  return { ...visualPoint, x: visualPoint.x / scaleX, y: visualPoint.y / scaleY }
}
